interface CallIconDefaultProps {
  /** Stroke color; white when selected, #999999 when inactive. */
  strokeColor?: string;
}

/**
 * Outline call icon for header navigation tabs.
 *
 * @param strokeColor - Icon stroke color (defaults to white for active state)
 */
const CallIconDefault = ({ strokeColor = "white" }: CallIconDefaultProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.36709 3.9987C10.0182 4.12574 10.6167 4.4442 11.0858 4.91332C11.5549 5.38244 11.8734 5.98087 12.0004 6.63203M9.36709 1.33203C10.7199 1.48232 11.9815 2.08815 12.9446 3.05004C13.9077 4.01192 14.5151 5.2727 14.6671 6.62536M6.81841 9.24074C6.01736 8.43969 5.38483 7.53393 4.92084 6.56752C4.88092 6.48439 4.86097 6.44283 4.84564 6.39023C4.79115 6.20333 4.83029 5.97382 4.94363 5.81554C4.97552 5.771 5.01363 5.73289 5.08984 5.65668C5.32291 5.42361 5.43944 5.30708 5.51563 5.18989C5.80296 4.74797 5.80296 4.17825 5.51563 3.73632C5.43944 3.61913 5.32291 3.5026 5.08984 3.26953L4.95992 3.13961C4.60563 2.78532 4.42848 2.60817 4.23823 2.51194C3.85985 2.32056 3.41301 2.32056 3.03464 2.51194C2.84438 2.60817 2.66723 2.78532 2.31294 3.13961L2.20785 3.2447C1.85477 3.59779 1.67823 3.77433 1.54339 4.01435C1.39378 4.28069 1.28621 4.69435 1.28712 4.99983C1.28793 5.27513 1.34134 5.46327 1.44814 5.83957C2.02212 7.86184 3.1051 9.77008 4.69709 11.3621C6.28908 12.954 8.19732 14.037 10.2196 14.611C10.5959 14.7178 10.784 14.7712 11.0593 14.772C11.3648 14.7729 11.7785 14.6654 12.0448 14.5158C12.2848 14.3809 12.4614 14.2044 12.8145 13.8513L12.9195 13.7462C13.2738 13.3919 13.451 13.2148 13.5472 13.0245C13.7386 12.6461 13.7386 12.1993 13.5472 11.8209C13.451 11.6307 13.2738 11.4535 12.9195 11.0992L12.7896 10.9693C12.5566 10.7362 12.44 10.6197 12.3228 10.5435C11.8809 10.2562 11.3112 10.2562 10.8693 10.5435C10.7521 10.6197 10.6355 10.7362 10.4025 10.9693C10.3263 11.0455 10.2882 11.0836 10.2436 11.1155C10.0853 11.2289 9.85582 11.268 9.66892 11.2135C9.61633 11.1982 9.57476 11.1782 9.49164 11.1383C8.52523 10.6743 7.61946 10.0418 6.81841 9.24074Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CallIconDefault;
